import { useEffect, useRef, useState } from 'react';
import './IntroOverlay.css';

const IntroOverlay = () => {
  const [hide, setHide] = useState(false);
  const videoV1Ref = useRef(null);
  const videoV3Ref = useRef(null);

useEffect(() => {
  const timer = setTimeout(() => setHide(true), 4000);

  const videoV1 = videoV1Ref.current;
  const videoV3 = videoV3Ref.current;

  const seekV1To3s = () => {
    if (videoV1) videoV1.currentTime = 3;
  };

  const seekV3To3s = () => {
    if (videoV3) videoV3.currentTime = 3;
  };

  videoV1?.addEventListener('loadedmetadata', seekV1To3s);
  videoV3?.addEventListener('loadedmetadata', seekV3To3s);

  return () => {
    clearTimeout(timer);
    videoV1?.removeEventListener('loadedmetadata', seekV1To3s);
    videoV3?.removeEventListener('loadedmetadata', seekV3To3s);
  };
}, []);


  return (
    <div className={`intro-overlay ${hide ? 'hide' : ''}`}>
      <div className="video-grid">
       <video
  ref={videoV1Ref}
  src="/videos/v1.mp4"
  autoPlay
  muted
  loop
  playsInline
  preload="auto"
  className="video-item"
/>

        <video
          ref={videoV3Ref}
          src="/videos/v3.mp4"
          autoPlay
          muted
          loop
          className="video-item"
        />
      </div>
    </div>
  );
};

export default IntroOverlay;
